export const cardBackground = [
  { back: '#A4BE82', border: 'rgba(206, 115, 115, 0.87)' },
  { back: '#C4BFD8', border: 'rgba(65, 49, 149, 0.87)' },
  { back: '#C4889F', border: 'rgba(204, 169, 46, 0.87)' },
  { back: '#FFF0D3', border: 'rgba(7, 34, 39, 0.87)' },
  { back: '#DBD282', border: 'rgba(28, 68, 63, 0.87)' },
  { back: '#B96363', border: 'rgba(193, 104, 22, 0.87)' },
  { back: '#9DCBCB', border: 'rgba(92, 30, 118, 0.87)' }
];
